import React, { useState, useEffect, useContext, useRef } from 'react';
import './PlanerTura.css';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from '../../Header/auth - context';
import { ChatSocketContext } from '../../context/ChatSocketContext';
import { useSelector } from 'react-redux';
import CustomDropdown from '../../custom/customDropdown';
import usePermission from '../../custom/usePermission';
import ConfirmationModalPlanner from '../../custom/ConfirmationModalPlanner';

const MONTHS = [
    { label: 'Januar', value: 1 }, { label: 'Februar', value: 2 }, { label: 'Mart', value: 3 },
    { label: 'April', value: 4 }, { label: 'Maj', value: 5 }, { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 }, { label: 'Avgust', value: 8 }, { label: 'Septembar', value: 9 },
    { label: 'Oktobar', value: 10 }, { label: 'Novembar', value: 11 }, { label: 'Decembar', value: 12 }
];

const DAY_SHORT = ['Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub', 'Ned'];
const DAY_FULL  = ['Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota', 'Nedjelja'];


const getDaysInMonth = (y, m) => new Date(y, m, 0).getDate();

const getMondayWeekday = (y, m, d) => {
    const js = new Date(y, m - 1, d).getDay();
    return js === 0 ? 6 : js - 1;
};

const buildWeeks = (year, month) => {
    const total  = getDaysInMonth(year, month);
    const offset = getMondayWeekday(year, month, 1);
    const cells  = Array(offset).fill(null);
    for (let d = 1; d <= total; d++) cells.push(d);
    while (cells.length % 7 !== 0) cells.push(null);
    const weeks = [];
    for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
    return weeks;
};

const TIP_LABEL = { 'Kabotaza': 'Kabotaža', 'Treca zemlja': 'Treća zemlja' };

/* Kartice se povecavaju i smanjuju kao zumom u pregledacu, ali SAMO one —
   kolone zadrzavaju sirinu, jer bi inace nedelja prestala da staje na ekran.
   Granice su iste kao u proceduri (60-140), da se front i baza ne raziđu. */
const SKALA_MIN = 60;
const SKALA_MAX = 140;
const SKALA_KORAK = 10;

/* Ključ je naziv iz šifarnika (`dbo.model_gen`, „Status plana ture") onakav
   kakav stigne iz procedure — po njemu se bira boja kartice i značke.

   Četiri statusa i njihove boje su dogovor sa korisnikom (zadatak 155):
   u pregovorima žuto, potvrđen plavo, utovaren zeleno, otkazan crveno.

   Stari nazivi stoje ispod namerno: okruženje u kom šifarnik još nije
   prebačen (modgen.sql se pušta zasebno) inače ostaje bez boja. Kad se
   pusti svuda, donja tri reda mogu da odu. */
const statusMeta = {
    'U pregovorima':           { cls: 'sc',  label: 'U pregovorima' },
    'Potvrđen':                { cls: 'sp',  label: 'Potvrđen' },
    'Utovaren':                { cls: 'su',  label: 'Utovaren' },
    'Otkazan':                 { cls: 'so',  label: 'Otkazan' },

    /* dok se šifarnik ne prebaci */
    'Čeka se za potvrdu':      { cls: 'sc',  label: 'Čeka se za potvrdu' },
    'Otkazano od prevoznika':  { cls: 'so',  label: 'Otkazano od prevoznika' },
    'Otkazano od nalogodavca': { cls: 'so2', label: 'Otkazano od nalogodavca' },
    'Završen':                 { cls: 'sz',  label: 'Završen' },
};

const emptyForm = {
    datum_utovara:    null,
    vreme_utovara:    null,
    tip_prevoza:      null,
    id_klijent:       null,
    mesto_utovara:    '',
    mesto_istovara:   '',
    id_vozilo:        null,
    id_prikljucno:    null,
    id_vozac:         null,
    tezina:           null,
    broj_paleta:      null,
    rezim:            null,
    napomena:         '',
    /* Neobavezna dopuna uz obavezan „Tekst" — kolona `detalji`. */
    detalji:          '',
    status_plana:     null,
    datum_ugovaranja: null,
};

const KalendarPlanaTure = ({ refreshKey }) => {
    const { t }   = useTranslation();
    const auth    = useContext(AuthContext);
    const company = useSelector(s => s.company);
    const { can } = usePermission();
    const toast   = useRef(null);
    const formRef = useRef(null);

    // ── Calendar state ──────────────────────────────────────────
    const now    = new Date();
    const todayY = now.getFullYear();
    const todayM = now.getMonth() + 1;
    const todayD = now.getDate();

    const [mesec,   setMesec]   = useState(todayM);
    const [godina,  setGodina]  = useState(todayY);
    const [calData, setCalData] = useState([]);
    const [selWeek, setSelWeek] = useState(null);

    // ── Modal / form state ───────────────────────────────────────
    const [confirmVisible,  setConfirmVisible]  = useState(false);
    const [idItem,          setIdItem]          = useState(null);
    const [izabran,         setIzabran]         = useState(false);
    const [formSubmitted,   setFormSubmitted]   = useState(false);
    const [formData,        setFormData]        = useState(emptyForm);

    // ── Dropdown data ────────────────────────────────────────────
    const [statusPlanerDB, setStatusPlanerDB] = useState([]);
    const [skala, setSkala] = useState(100);
    const [izborNedelje, setIzborNedelje] = useState(false);   // padajuci mini kalendar
    const [ceoEkran, setCeoEkran] = useState(false);
    const okvirKalendara = useRef(null);
    /* Kad se nedeljom predje granica meseca, mesec se menja stanjem, pa se nova
       lista nedelja dobija tek u sledecem prolazu. Ovde se pamti KOJA nedelja
       novog meseca treba da bude izabrana — prva kad se ide unapred, poslednja
       kad se ide unazad. */
    const zeljenaNedelja = useRef(null);
    const { socket } = useContext(ChatSocketContext) || {};
    const [klijentiDB,     setKlijentiDB]     = useState([]);
    const [vozilaDB,       setVozilaDB]       = useState([]);
    const [prikljucnaDB,   setPrikljucnaDB]   = useState([]);
    const [vozaciDB,       setVozaciDB]       = useState([]);
    const [rezimDB,        setRezimDB]        = useState([]);
    const [tipPrevozeDB,   setTipPrevozeDB]   = useState([]);

    // ── Helpers ──────────────────────────────────────────────────
    const handleErrors = r => { if (r.ok) return r.json(); throw r; };

    const toUtcIso = (d) => {
        if (!d) return null;
        const x = d instanceof Date ? d : new Date(d);
        const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
        return utc.toISOString().slice(0, 19) + 'Z';
    };

    /* Vreme se u bazi čuva kao TIME; ovde se prevodi u Date (za Calendar) i nazad. */
    const vremeUDate = (v) => {
        if (!v) return null;
        if (v instanceof Date) return v;
        const m = /^(\d{2}):(\d{2})/.exec(String(v));
        if (!m) { const d = new Date(v); return isNaN(d.getTime()) ? null : d; }
        const d = new Date();
        d.setHours(Number(m[1]), Number(m[2]), 0, 0);
        return d;
    };

    const vremeUString = (v) => {
        if (!v) return null;
        const d = v instanceof Date ? v : vremeUDate(v);
        if (!d) return null;
        return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:00`;
    };

    const invalidControl = (data) => {
        if (!formSubmitted) return false;
        if (data && data != null && !Number(data)) return data.length > 0 ? false : true;
        else if (data != null && Number(data)) return false;
        return true;
    };

    // ── Fetch calendar data ──────────────────────────────────────
    const fetchCalendar = () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageTripPlanner', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ step: 'GET', mesec, godina })
        })
            .then(handleErrors)
            .then(data => setCalData(data || []))
            .catch(err => err.json && err.json().then(e =>
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: e.message, life: 4000 })
            ));
    };

    /* Nova vrednost se odmah vidi na ekranu, a u bazu ide tek kad korisnik
       prestane da klika — inace bi svaki korak po skali bio jedan upit.
       Ako snimanje padne, prikaz ostaje promenjen: to je postavka izgleda, ne
       podatak, pa nema smisla vracati korisnika unazad zbog mrezne greske. */
    const snimiSkalu = useRef(null);
    const promeniSkalu = (nova) => {
        const v = Math.min(SKALA_MAX, Math.max(SKALA_MIN, nova));
        setSkala(v);
        if (snimiSkalu.current) clearTimeout(snimiSkalu.current);
        snimiSkalu.current = setTimeout(() => {
            fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageTripPlanner', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
                body: JSON.stringify({ step: 'SKALA', formData: { skala: v } })
            }).catch(() => {});
        }, 600);
    };

    /* Osvezavanje uzivo. Slusalac se vezuje jednom (za ceo zivot komponente), a
       kroz ref uvek zove NAJNOVIJI fetchCalendar — da se ne prevezuje pri svakoj
       promeni meseca i da ne povuce zastareo mesec iz stare closure.
       Osvezava se i kad je izmena nasa: jedan upit je jeftiniji od grananja, a
       ovako se vidi i sta je server stvarno upisao. */
    const osveziRef = useRef(null);
    osveziRef.current = fetchCalendar;

    useEffect(() => {
        // Zavisi od socket STANJA, ne od ref-a — vidi ChatSocketContext.js.
        if (!socket) return;
        const naIzmenu = () => osveziRef.current?.();
        socket.on('planer:izmena', naIzmenu);
        return () => socket.off('planer:izmena', naIzmenu);
    }, [socket]);

    /* Isti obrazac kao na GPS mapi: trazi se pravi fullscreen pregledaca, a ako
       ga pregledac odbije (iframe bez dozvole, stariji Safari), pada se na CSS
       koji element razvuce preko prozora. */
    const prebaciCeoEkran = () => {
        const el = okvirKalendara.current;
        if (!el) return;
        if (document.fullscreenElement) { document.exitFullscreen?.(); return; }
        if (el.requestFullscreen) el.requestFullscreen().catch(() => setCeoEkran(v => !v));
        else setCeoEkran(v => !v);
    };

    /* Visina se MERI, ne pogadja. Kalendar ne zna sta je iznad njega (zaglavlje
       aplikacije, sub-navigacija, forma za unos koja se siri i skuplja), pa se
       njegov gornji rub cita iz rasporeda i ostatak ekrana daje telu kalendara.
       Fiksnih 78vh je uvek ostavljalo ili prazan pojas ili skrol. */
    useEffect(() => {
        const el = okvirKalendara.current;
        if (!el) return;
        let poslednja = null;
        let kadar = 0;

        const izmeri = () => {
            const telo = el.querySelector('.pk-body');
            if (!telo) return;
            const vrh = Math.max(0, Math.round(telo.getBoundingClientRect().top));
            /* Upis samo kad se vrednost STVARNO promenila. Bez ove provere
               svako merenje menja visinu, promena visine budi posmatraca, i
               pregledac prijavi "ResizeObserver loop completed with undelivered
               notifications". */
            if (vrh === poslednja) return;
            poslednja = vrh;
            el.style.setProperty('--pk-vrh', `${vrh}px`);
        };

        /* Upis se odlaze za sledeci kadar, van same isporuke dogadjaja — tako
           promena rasporeda ne pada u isti ciklus u kom je posmatrac pozvan. */
        const zakazi = () => {
            cancelAnimationFrame(kadar);
            kadar = requestAnimationFrame(izmeri);
        };

        izmeri();
        window.addEventListener('resize', zakazi);
        /* Traka ume da se prelomi u dva reda (uzak ekran), cime se telo pomeri
           nadole — ResizeObserver to hvata, obican resize dogadjaj ne bi. */
        const posmatrac = new ResizeObserver(zakazi);
        posmatrac.observe(el);
        return () => {
            cancelAnimationFrame(kadar);
            window.removeEventListener('resize', zakazi);
            posmatrac.disconnect();
        };
    }, []);

    /* Stanje se cita iz pregledaca, ne pamti se lokalno — iz celog ekrana se
       izlazi i tasterom Esc, mimo naseg dugmeta. */
    useEffect(() => {
        const naPromenu = () => setCeoEkran(!!document.fullscreenElement);
        document.addEventListener('fullscreenchange', naPromenu);
        return () => document.removeEventListener('fullscreenchange', naPromenu);
    }, []);

    // ── Fetch dropdown types ─────────────────────────────────────
    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageTripPlanner', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ step: 'GETTYPES' })
        })
            .then(handleErrors)
            .then(data => {
                const parsed = JSON.parse(data[0]['JsonOutput']);
                setStatusPlanerDB(parsed.StatusPlanerDB);
                if (parsed.Skala) setSkala(Number(parsed.Skala));
                setKlijentiDB(parsed.KlijentiDB);
                setVozilaDB(parsed.VozilaDB);
                setPrikljucnaDB(parsed.PrikljucnaDB);
                setVozaciDB(parsed.VozaciDB);
                setRezimDB(parsed.RezimDB);
                setTipPrevozeDB(parsed.TipPrevozeDB);
            })
            .catch(err => err.json && err.json().then(e =>
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: e.message, life: 3000 })
            ));
    }, []);

    useEffect(() => { fetchCalendar(); }, [company, mesec, godina, refreshKey]);

    useEffect(() => {
        const weeks = buildWeeks(godina, mesec);

        /* Prelazak preko granice meseca strelicama ima prednost nad "skoci na
           danasnju nedelju" — korisnik je izricito trazio susednu nedelju. */
        if (zeljenaNedelja.current) {
            setSelWeek(zeljenaNedelja.current === 'poslednja' ? Math.max(0, weeks.length - 1) : 0);
            zeljenaNedelja.current = null;
            return;
        }

        if (godina === todayY && mesec === todayM) {
            const wi = weeks.findIndex(w => w.includes(todayD));
            setSelWeek(wi >= 0 ? wi : 0);
        } else {
            setSelWeek(0);
        }
    }, [mesec, godina]);

    // ── Form handlers ────────────────────────────────────────────
    const handleChange = (e) => {
        const { name, value } = e.target || e;
        if (name in formData) setFormData(prev => ({ ...prev, [name]: value }));
    };

    const popuniStavke = (apiData) => {
        setFormData({
            datum_utovara:    apiData.datum_utovara    ? new Date(apiData.datum_utovara)    : null,
            /* TIME iz baze stiže kao '08:30:00' ili kao Date — svodi se na Date za Calendar */
            vreme_utovara:    vremeUDate(apiData.vreme_utovara),
            tip_prevoza:      apiData.tip_prevoza      || null,
            id_klijent:       apiData.id_klijent       || null,
            mesto_utovara:    apiData.mesto_utovara    || '',
            mesto_istovara:   apiData.mesto_istovara   || '',
            id_vozilo:        apiData.id_vozilo        || null,
            id_prikljucno:    apiData.id_prikljucno    || null,
            id_vozac:         apiData.id_vozac         || null,
            tezina:           apiData.tezina           || null,
            broj_paleta:      apiData.broj_paleta      || null,
            rezim:            apiData.rezim            || null,
            napomena:         apiData.napomena         || '',
            detalji:          apiData.detalji          || '',
            status_plana:     apiData.status_plana     || null,
            datum_ugovaranja: apiData.datum_ugovaranja ? new Date(apiData.datum_ugovaranja) : null,
        });
    };

    const popuniRedove = async (id) => {
        setIzabran(true);
        await fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageTripPlanner', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ id, step: 'GET' })
        })
            .then(handleErrors)
            .then(data => {
                if (data.message) {
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: data.message, life: 3000 });
                    return;
                }
                popuniStavke(data[0]);
            })
            .catch(err => err.json && err.json().then(e =>
                toast.current?.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 })
            ));
    };

    const closeModal = () => {
        setConfirmVisible(false);
        setIdItem(null);
        setIzabran(false);
        setFormSubmitted(false);
        setFormData(emptyForm);
    };

    const handleEventClick = async (entry) => {
        const id = entry.Izaberi;
        setIdItem(id);
        await popuniRedove(id);
        setConfirmVisible(true);
    };

    /* Dvoklik na prazno polje u nedeljnoj mreži otvara BRZI unos:
       tip prevoza se uzima iz reda (uvoz/izvoz), datum iz kolone — korisniku
       ostaje samo tekst i status. */
    const handleCellDoubleClick = (dan, rowKey) => {
        if (!dan || !can('PLANER', 'edit')) return;
        if (rowKey === 'ostalo') return;          // taj red nije jedan tip prevoza

        const trazeniOpis = rowKey === 'uvoz' ? 'Uvoz' : 'Izvoz';
        const tip = (tipPrevozeDB || []).find(
            o => String(o.label).trim().toLowerCase() === trazeniOpis.toLowerCase()
        );

        setIdItem(null);
        setIzabran(false);
        setFormSubmitted(false);
        setFormData({
            ...emptyForm,
            datum_utovara: new Date(godina, mesec - 1, dan, 8, 0, 0),
            tip_prevoza:   tip ? tip.value : null,
        });
        setConfirmVisible(true);
    };

    /* Prva četiri polja su obavezna za svaku stavku; detalji su dobrovoljni i
       mogu se popuniti uz slobodan tekst. */
    const nedostajuObavezna = () =>
        String(formData.napomena || '').trim() === ''
        || !formData.tip_prevoza
        || !formData.datum_utovara
        || !formData.status_plana;

    const handleFormSubmitItems = (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        if (formRef.current && !formRef.current.checkValidity()) {
            formRef.current.reportValidity();
            return;
        }
        if (nedostajuObavezna()) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Nedostaju obavezna polja',
                detail: 'Tekst, tip prevoza, datum utovara i status su obavezni.',
                life: 4000,
            });
            return;
        }
        confirmDialog({
            message: 'Jel ste sigurni da želite sačuvati stavku planera?',
            acceptLabel: 'Da',
            rejectLabel: 'Ne',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: acceptSaveItems,
        });
    };

    const acceptSaveItems = async () => {
        const payload = {
            ...formData,
            datum_utovara:    toUtcIso(formData.datum_utovara),
            datum_ugovaranja: toUtcIso(formData.datum_ugovaranja),
            vreme_utovara:    vremeUString(formData.vreme_utovara),
        };
        /* Nova stavka (dvoklik na prazno polje) ide na INSERT, postojeća na UPDATE. */
        const step = idItem ? 'UPDATE' : 'INSERT';
        try {
            await fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageTripPlanner', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
                body: JSON.stringify({ id: idItem, step, formData: payload })
            })
                .then(handleErrors)
                .then(data => {
                    if (data[0]?.message && data[0].message !== 'Nema izmena u podacima planera.') {
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: data[0].message, life: 3000 });
                        return;
                    }
                    if (data[0]?.message === 'Nema izmena u podacima planera.') {
                        toast.current?.show({ severity: 'warn', summary: data[0].message, life: 3000 });
                    } else {
                        toast.current?.show({ severity: 'success', summary: 'Uspešna izmena podataka stavke!', life: 3000 });
                        closeModal();
                        fetchCalendar();
                    }
                });
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Greška', detail: 'Neuspešno čuvanje stavke.', life: 3000 });
        }
    };

    const handleFormRemoveItems = () => {
        confirmDialog({
            message: 'Jel ste sigurni da želite pasivizirati stavku planera?',
            acceptLabel: 'Da',
            rejectLabel: 'Ne',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: acceptRemoveItems,
        });
    };

    const acceptRemoveItems = async () => {
        if (!idItem) return;
        await fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageTripPlanner', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ id: idItem, step: 'DELETE' })
        })
            .then(handleErrors)
            .then(data => {
                if (data.message) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje!', detail: data.message, life: 3000 });
                    return;
                }
                toast.current?.show({ severity: 'success', summary: 'Uspešno!', detail: 'Uspešno ste pasivizirali stavku planera!', life: 3000 });
                closeModal();
                fetchCalendar();
            })
            .catch(err => err.json && err.json().then(e =>
                toast.current?.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 })
            ));
    };

    // ── Calendar lookups ─────────────────────────────────────────
    const lookup = {};
    calData.forEach(row => {
        const d = row.dan;
        if (!d) return;
        if (!lookup[d]) lookup[d] = [];
        lookup[d].push(row);
    });
    /* SP već vraća pravi redosled (vreme rastuće, pa DateEntered); ovde se samo
       čuva stabilnost ako se nizovi mešaju iz više izvora. */
    Object.values(lookup).forEach(arr => arr.sort((a, b) => {
        const va = a['Vreme utovara'] || '';
        const vb = b['Vreme utovara'] || '';
        if (va && vb) return va.localeCompare(vb);
        if (va) return -1;
        if (vb) return 1;
        return (a.Izaberi || 0) - (b.Izaberi || 0);
    }));

    const weeks     = buildWeeks(godina, mesec);
    const isToday   = d => d && godina === todayY && mesec === todayM && d === todayD;
    const monthName = MONTHS.find(m => m.value === mesec)?.label || '';

    const prevMonth = () => { if (mesec === 1) { setMesec(12); setGodina(y => y - 1); } else setMesec(m => m - 1); };
    const nextMonth = () => { if (mesec === 12) { setMesec(1); setGodina(y => y + 1); } else setMesec(m => m + 1); };

    /* Nedelja po nedelja, preko granice meseca. Bez ovoga bi se na prvoj i
       poslednjoj nedelji strelica jednostavno ugasila, pa bi se za susednu
       nedelju moralo rucno menjati mesec. */
    const prevWeek = () => {
        if ((selWeek ?? 0) > 0) { setSelWeek(w => w - 1); return; }
        zeljenaNedelja.current = 'poslednja';
        prevMonth();
    };

    const nextWeek = () => {
        if ((selWeek ?? 0) < buildWeeks(godina, mesec).length - 1) { setSelWeek(w => (w ?? 0) + 1); return; }
        zeljenaNedelja.current = 'prva';
        nextMonth();
    };

    const currentWeek = selWeek !== null ? (weeks[selWeek] || weeks[0] || []) : (weeks[0] || []);

    const weekLabel = (() => {
        const days = currentWeek.filter(Boolean);
        if (!days.length) return '';
        const first = days[0], last = days[days.length - 1];
        return `${first}. – ${last}. ${monthName} ${godina}`;
    })();

    // ── Grupisanje po tipu prevoza: izvoz / uvoz / ostalo (kabotaža + treća zemlja) ──
    const tipRows = [
        { key: 'uvoz',   label: 'UVOZ',   filter: e => e['Tip prevoza'] === 'Uvoz' },
        { key: 'izvoz',  label: 'IZVOZ',  filter: e => e['Tip prevoza'] === 'Izvoz' },
        { key: 'ostalo', label: 'OSTALO', filter: e => e['Tip prevoza'] !== 'Izvoz' && e['Tip prevoza'] !== 'Uvoz' },
    ];

    const renderEvent = (entry, ei, showTip) => {
        const sc   = statusMeta[entry['Status']]?.cls || '';
        const ruta = [entry['Mesto utovara'], entry['Mesto istovara']].filter(Boolean).join(' → ');
        const time = entry['Vreme utovara'] || '';
        /* "vučno / priključno", ali kosa crta samo kad postoje OBA — inače bi
           kartica sa samo jednim vozilom vukla praznu crtu za sobom.
           FOR JSON PATH izostavlja ključ kad je vrednost NULL, pa se oba polja
           moraju proveravati, ne samo prazan string. */
        const vozila = [entry['Vozilo'], entry['Priključno']].filter(Boolean).join(' / ');
        return (
            <div
                key={ei}
                className={`pk-event pk-event-${sc}`}
                onDoubleClick={(e) => { e.stopPropagation(); handleEventClick(entry); }}
                title={`${entry['Klijent'] || 'Nema klijenta'}${vozila ? ' | ' + vozila : ''}${ruta ? ' | ' + ruta : ''}${entry['Firma'] ? ' | ' + entry['Firma'] : ''}`}
            >
                {/* Slobodan tekst je naslov kartice — to je ono što korisnik piše da
                    bi na prvi pogled znao o čemu je plan. Klijent ide ispod, ako postoji. */}
                {entry['Napomena'] && (
                    <div className="pk-ev-slobodan">{entry['Napomena']}</div>
                )}
                {(entry['Klijent'] || !entry['Napomena']) && (
                    <div className={`pk-ev-klijent${entry['Klijent'] ? '' : ' pk-ev-nepovezan'}`}>
                        {entry['Klijent'] || 'Nema klijenta'}
                    </div>
                )}
                {showTip && entry['Tip prevoza'] &&
                    <div className="pk-ev-tip">{TIP_LABEL[entry['Tip prevoza']] || entry['Tip prevoza']}</div>}
                <div className="pk-ev-row2">
                    {/* Vreme i vozila idu zajedno levo, status ostaje desno — inače
                        bi ih "space-between" razbacao po tri ćoška. */}
                    <span className="pk-ev-levo">
                        {time && <span className="pk-ev-time">⏱ {time}</span>}
                        {vozila && <span className="pk-ev-vozilo pk-ev-voz">{vozila}</span>}
                    </span>
                    {entry['Status'] && <span className={`pk-ev-status pk-chip-${sc}`}>{entry['Status']}</span>}
                </div>
            </div>
        );
    };

    // OSTALO se prikazuje samo ako u toj nedelji ima takvih planova; izvoz/uvoz uvek.
    const weekEntries = currentWeek.filter(Boolean).flatMap(d => lookup[d] || []);
    const ostaloHas   = weekEntries.some(tipRows.find(r => r.key === 'ostalo').filter);
    const visibleRows = tipRows.filter(r => r.key !== 'ostalo' || ostaloHas);

    // ── Render ───────────────────────────────────────────────────
    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />

            {/* ── Edit modal ── */}
            <ConfirmationModalPlanner
                visible={confirmVisible}
                onHide={closeModal}
                onConfirmRemove={can('PLANER', 'delete') ? handleFormRemoveItems : undefined}
                idItem={idItem}
            >
                <form autoComplete="off" ref={formRef} style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {/* ── SLOBODAN UNOS: tekst + tri polja koja dele oba načina ── */}
                    <div className="pk-form-naslov">OBAVEZNO</div>
                    <div className="gridLicni">
                        <div className="pk-polje-puno" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="napomena">Tekst:</label>
                            <InputTextarea id="napomena" name="napomena"
                                value={formData.napomena} onChange={handleChange}
                                required invalid={invalidControl(formData.napomena)}
                                rows={3} autoResize
                                placeholder="Kratak opis plana" />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="tip_prevoza">Tip prevoza:</label>
                            <CustomDropdown id="tip_prevoza" name="tip_prevoza"
                                value={formData.tip_prevoza} options={tipPrevozeDB || []}
                                optionLabel="label" required invalid={invalidControl(formData.tip_prevoza)}
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="datum_utovara">Datum utovara:</label>
                            <Calendar id="datum_utovara" name="datum_utovara"
                                value={formData.datum_utovara} onChange={handleChange}
                                dateFormat="dd.mm.yy" mask="99.99.9999" showButtonBar required
                                invalid={invalidControl(formData.datum_utovara)} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="status_plana">Status:</label>
                            <CustomDropdown id="status_plana" name="status_plana"
                                value={formData.status_plana} options={statusPlanerDB || []}
                                optionLabel="label" required invalid={invalidControl(formData.status_plana)}
                                onChange={handleChange} />
                        </div>
                    </div>

                    <hr className="pk-form-linija" />

                    {/* ── DETALJNIJI UNOS: popunjava se umesto slobodnog teksta, ne uz njega ── */}
                    <div className="pk-form-naslov">
                        DETALJI
                        <span className="pk-form-napomena">nije obavezno — popunite ako imate podatke</span>
                    </div>
                    <div className="gridLicni">
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="vreme_utovara">Vreme utovara:</label>
                            <Calendar id="vreme_utovara" name="vreme_utovara"
                                value={formData.vreme_utovara} onChange={handleChange}
                                timeOnly hourFormat="24" mask="99:99" showButtonBar />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="datum_ugovaranja">Datum ugovaranja:</label>
                            <Calendar id="datum_ugovaranja" name="datum_ugovaranja"
                                value={formData.datum_ugovaranja} onChange={handleChange}
                                mask="99.99.9999" dateFormat="dd.mm.yy" showButtonBar />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_klijent">Klijent (nalogodavac):</label>
                            <CustomDropdown id="id_klijent" name="id_klijent"
                                value={formData.id_klijent} options={klijentiDB || []}
                                optionLabel="label"
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="mesto_utovara">Mesto utovara:</label>
                            <InputText id="mesto_utovara" name="mesto_utovara"
                                value={formData.mesto_utovara} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="mesto_istovara">Mesto istovara:</label>
                            <InputText id="mesto_istovara" name="mesto_istovara"
                                value={formData.mesto_istovara} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_vozilo">Vozilo:</label>
                            <CustomDropdown id="id_vozilo" name="id_vozilo"
                                value={formData.id_vozilo} options={vozilaDB || []}
                                optionLabel="label"
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_prikljucno">Priključno vozilo:</label>
                            <CustomDropdown id="id_prikljucno" name="id_prikljucno"
                                value={formData.id_prikljucno} options={prikljucnaDB || []}
                                optionLabel="label" onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_vozac">Vozač:</label>
                            <CustomDropdown id="id_vozac" name="id_vozac"
                                value={formData.id_vozac} options={vozaciDB || []}
                                optionLabel="label" onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="rezim">Režim (npr. hladnjača):</label>
                            <CustomDropdown id="rezim" name="rezim"
                                value={formData.rezim} options={rezimDB || []}
                                optionLabel="label"
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="tezina">Težina (t):</label>
                            <InputNumber id="tezina" name="tezina"
                                value={formData.tezina} onValueChange={handleChange}
                                minFractionDigits={0} maxFractionDigits={2} locale="de-DE" />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="broj_paleta">Broj paleta:</label>
                            <InputNumber id="broj_paleta" name="broj_paleta"
                                value={formData.broj_paleta} onValueChange={handleChange} />
                        </div>
                        {/* Dopuna na kraju: ono sto se ne uklapa u polja iznad. Nije obavezna. */}
                        <div className="pk-polje-puno" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="detalji">{t('plan.napomena')}:</label>
                            <InputTextarea id="detalji" name="detalji"
                                value={formData.detalji} onChange={handleChange}
                                rows={3} autoResize
                                placeholder={t('plan.napomenaPh')} />
                        </div>
                    </div>
                    <div className="formUnosZap buttonUnosZap" style={{ minWidth: '100%' }}>
                        <button type="submit" onClick={handleFormSubmitItems}
                            disabled={!can('PLANER', 'edit')}
                            style={{ minWidth: 'fit-content', minHeight: 'fit-content', marginTop: '2%' }}
                            className="btn btn-success">
                            SAČUVAJ
                        </button>
                    </div>
                </form>
            </ConfirmationModalPlanner>

            {/* ── Calendar ── */}
            {/* Skala ide kao CSS promenljiva, pa je citaju samo pravila kartica —
                sirina kolona i zaglavlja ostaju netaknuti. */}
            <div className={`pk-root${ceoEkran ? ' pk-root-ceo' : ''}`}
                 ref={okvirKalendara}
                 style={{ '--pk-skala': skala / 100 }}>
                {/* Controls */}
                <div className="pk-controls">
                    {/* Ceo ekran je prvo dugme — najcesca radnja kad se planira
                        nedelja je da se dobije sto vise mesta. */}
                    <Button icon={ceoEkran ? 'pi pi-window-minimize' : 'pi pi-window-maximize'}
                            text className="pk-nav-btn"
                            onClick={prebaciCeoEkran}
                            tooltip={ceoEkran ? 'Izađi iz celog ekrana' : 'Ceo ekran'}
                            tooltipOptions={{ position: 'bottom' }} />
                    <span className="pk-crta" aria-hidden="true">|</span>
                    {/* Izbor nedelje: strelice pomeraju nedelju, a sama oznaka otvara
                        kalendar. Navigacija po mesecu stoji SAMO u tom kalendaru —
                        ranije je stajala i u traci, pa su dve kontrole radile isti
                        posao. Kalendar je i inace padajuci: kao stalna leva kolona
                        trosio je ~210px na nesto sto se dira jednom u par dana. */}
                    <div className="pk-izbor-nedelje">
                        <Button icon="pi pi-chevron-left" text onClick={prevWeek} className="pk-nav-btn"
                                tooltip="Prethodna nedelja" tooltipOptions={{ position: 'bottom' }} />
                        {/* Sama oznaka otvara kalendar — ikona je u njoj, pa nema
                            zasebnog dugmeta koje radi istu stvar. */}
                        <button type="button" className="pk-week-label pk-week-label-dugme"
                                onClick={() => setIzborNedelje(o => !o)}
                                title="Izaberi nedelju">
                            <i className="pi pi-calendar" />
                            <span>Nedelja: {weekLabel || '—'}</span>
                        </button>
                        <Button icon="pi pi-chevron-right" text onClick={nextWeek} className="pk-nav-btn"
                                tooltip="Sledeća nedelja" tooltipOptions={{ position: 'bottom' }} />
                        {izborNedelje && (
                            <>
                                {/* Klik van panela ga zatvara — bez ovoga bi ostajao otvoren
                                    preko planova dok se ne klikne bas na dugme. */}
                                <div className="pk-mini-zastor" onClick={() => setIzborNedelje(false)} />
                            <div className="pk-mini-cal">
                                {/* Svoja traka za mesec: bez nje bi korisnik morao da
                                    zatvori popup, promeni mesec u glavnoj traci i opet
                                    ga otvori samo da bi video nedelje drugog meseca. */}
                                <div className="pk-mini-traka">
                                    <button type="button" className="pk-mini-strelica"
                                            onClick={prevMonth} aria-label="Prethodni mesec">
                                        <i className="pi pi-chevron-left" />
                                    </button>
                                    <span className="pk-mini-mesec">{monthName} {godina}</span>
                                    <button type="button" className="pk-mini-strelica"
                                            onClick={nextMonth} aria-label="Sledeći mesec">
                                        <i className="pi pi-chevron-right" />
                                    </button>
                                </div>
                                <table className="pk-mini-table">
                                    <thead>
                                        <tr>
                                            {DAY_SHORT.map((lbl, i) => (
                                                <th key={i} className={i >= 5 ? 'pk-mini-th pk-mini-th-we' : 'pk-mini-th'}>{lbl}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {weeks.map((week, wi) => {
                                            const isSel = wi === selWeek;
                                            return (
                                                <tr
                                                    key={wi}
                                                    className={isSel ? 'pk-mini-row pk-mini-row-sel' : 'pk-mini-row'}
                                                    onClick={() => { setSelWeek(wi); setIzborNedelje(false); }}
                                                >
                                                    {week.map((d, di) => {
                                                        const isWe  = di >= 5;
                                                        const isTd  = isToday(d);
                                                        const hasEv = d && lookup[d]?.length > 0;
                                                        let cls = 'pk-mini-td';
                                                        if (!d)   cls += ' pk-mini-td-empty';
                                                        if (isWe) cls += ' pk-mini-td-we';
                                                        return (
                                                            <td key={di} className={cls}>
                                                                <span className={isTd ? 'pk-mini-day pk-mini-day-today' : 'pk-mini-day'}>
                                                                    {d || ''}
                                                                </span>
                                                                {hasEv && <span className="pk-mini-dot" />}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            </>
                        )}
                    </div>
                    <span className="pk-crta" aria-hidden="true">|</span>
                    <Button icon="pi pi-refresh" text onClick={fetchCalendar} className="pk-nav-btn"
                            tooltip="Osveži" tooltipOptions={{ position: 'bottom' }} />
                    <span className="pk-crta" aria-hidden="true">|</span>
                    {/* Zum kartica — poslednji u traci. */}
                    <div className="pk-zum">
                        <Button icon="pi pi-search-minus" text className="pk-nav-btn"
                                disabled={skala <= SKALA_MIN}
                                onClick={() => promeniSkalu(skala - SKALA_KORAK)}
                                tooltip="Smanji kartice" tooltipOptions={{ position: 'top' }} />
                        <input
                            type="range"
                            className="pk-zum-klizac"
                            min={SKALA_MIN}
                            max={SKALA_MAX}
                            step={SKALA_KORAK}
                            value={skala}
                            onChange={(e) => promeniSkalu(Number(e.target.value))}
                            aria-label="Veličina kartica"
                        />
                        <Button icon="pi pi-search-plus" text className="pk-nav-btn"
                                disabled={skala >= SKALA_MAX}
                                onClick={() => promeniSkalu(skala + SKALA_KORAK)}
                                tooltip="Uvećaj kartice" tooltipOptions={{ position: 'top' }} />
                        <span className="pk-zum-broj">{skala}%</span>
                        {skala !== 100 && (
                            <Button label="100%" text className="pk-zum-reset"
                                    onClick={() => promeniSkalu(100)} />
                        )}
                    </div>
                </div>

                {/* Body */}
                <div className="pk-body">


                    {/* RIGHT: weekly detail view — CSS grid (jednaki redovi po tipu) */}
                    <div className="pk-week-panel">
                        <div
                            className="pk-week-grid"
                            style={{ gridTemplateRows: `auto repeat(${visibleRows.length}, minmax(0, 1fr))` }}
                        >
                            {/* header */}
                            <div className="pk-wg-corner" />
                            {currentWeek.map((d, di) => {
                                const isWe = di >= 5;
                                const isTd = isToday(d);
                                let cls = 'pk-wg-th';
                                if (isWe) cls += ' pk-week-th-we';
                                if (isTd) cls += ' pk-week-th-today';
                                const cnt = d ? (lookup[d]?.length || 0) : 0;
                                return (
                                    <div key={`h${di}`} className={cls}>
                                        {d
                                            ? <><span className="pk-wh-day">{d}.</span><span className="pk-wh-name">{DAY_FULL[di]}</span></>
                                            : <span className="pk-wh-name">{DAY_FULL[di]}</span>
                                        }
                                        {cnt > 0 && <span className="pk-wh-cnt">{cnt}</span>}
                                    </div>
                                );
                            })}
                            {/* type rows */}
                            {visibleRows.map(row => (
                                <React.Fragment key={row.key}>
                                    <div className={`pk-wg-label pk-row-label-${row.key}`}>{row.label}</div>
                                    {currentWeek.map((d, di) => {
                                        const entries = (d ? (lookup[d] || []) : []).filter(row.filter);
                                        const isWe = di >= 5;
                                        return (
                                            <div key={`${row.key}${di}`}
                                                className={`pk-wg-cell${isWe ? ' pk-week-td-we' : ''}${d && row.key !== 'ostalo' ? ' pk-wg-cell-nova' : ''}`}
                                                onDoubleClick={() => handleCellDoubleClick(d, row.key)}
                                                title={d && row.key !== 'ostalo' ? 'Dvoklik — brzi unos plana' : undefined}>
                                                {entries.map((entry, ei) => renderEvent(entry, ei, row.key === 'ostalo'))}
                                            </div>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
};

export default KalendarPlanaTure;
